import { WidgetRegistry } from "@Widgets/types";
import { Recommendations, SidebarCTA } from "../index";

const recommendationsWidgetRegistry: Pick<
    WidgetRegistry,
    "Home.Recommendations" | "Home.SidebarCTA"
> = {
    "Home.Recommendations": {
        Component: Recommendations,
    },
    "Home.SidebarCTA": {
        Component: SidebarCTA,
    },
};

export default recommendationsWidgetRegistry;
